export default function buildDonationDetail(donationDetails) {
    const donationDetail = {
        donorRecognition: donationDetails.donorRecognitionType === "organization"
            ? donationDetails.organizationName
            : donationDetails.donorRecognitionType,
        donorRecognitionType: donationDetails.donorRecognitionType,
        notes: donationDetails.notes,
    };
    
    if(donationDetails.hasBeneficiary) {
        donationDetail.dedicationFirstName = donationDetails.dedicationFirstName;
        donationDetail.dedicationLastName = donationDetails.dedicationLastName;
        donationDetail.beneficiaryType = donationDetails.beneficiaryType;

        if(
            donationDetails.beneficiaryFirstName
            || donationDetails.beneficiaryLastName
            || donationDetails.email
            || donationDetails.beneficiaryPhoneNumber
        ) {
            donationDetail.beneficiaryFirstName = donationDetails.beneficiaryFirstName;
            donationDetail.beneficiaryLastName = donationDetails.beneficiaryLastName;
            donationDetail.beneficiaryEmail = donationDetails.beneficiaryEmail;
            donationDetail.beneficiaryPhoneNumber = donationDetails.beneficiaryPhoneNumber;
            donationDetail.beneficiaryStreetAddress1 = donationDetails.beneficiaryStreetAddress1;
            donationDetail.beneficiaryStreetAddress2 = "";
            donationDetail.beneficiaryCity = donationDetails.beneficiaryCity;
            donationDetail.beneficiaryState = donationDetails.beneficiaryState;
            donationDetail.beneficiaryCountry = donationDetails.beneficiaryCountry;
        }
    }

    return donationDetail;
}